export default function normalizeCategory(category) {
  const normalized = Object.entries(category).reduce((result, [key, value]) => {
    const normalizedKey =
      key.toLowerCase() === "id"
        ? "id"
        : `${key.charAt(0).toLowerCase()}${key.slice(1)}`;
    result[normalizedKey] = value;
    return result;
  }, {});

  normalized.id = category.id ?? category.iD ?? category.ID;

  return normalized;
}
